export const FORM_BLOCK_LAYOUT_CLASS_NAME = 'mx-auto w-full max-w-2xl';
